import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import Title from './title';
import money, { format } from '../lib/money';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  yourShare: {
    id: 'feesBreakdown.shareAmountTitle.yourShare',
    defaultMessage: 'Your share',
  },
  perSlot: {
    id: 'feesBreakdown.shareAmountTitle.perSlot',
    defaultMessage: '{slots} {slotsName} ({amount} each)',
  },
  perSlot_adult: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_adult',
    defaultMessage: '{slots} adults ({amount} each)',
  },
  perSlot_passenger: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_passenger',
    defaultMessage: '{slots} passengers ({amount} each)',
  },
  perSlot_ticket: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_ticket',
    defaultMessage: '{slots} tickets ({amount} each)',
  },
  perSlot_seat: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_seat',
    defaultMessage: '{slots} seats ({amount} each)',
  },
  perSlot_item: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_item',
    defaultMessage: '{slots} items ({amount} each)',
  },
  perSlot_shirt: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_shirt',
    defaultMessage: '{slots} shirts ({amount} each)',
  },
  perSlot_person: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_person',
    defaultMessage: '{slots} people ({amount} each)',
  },
  perSlot_guest: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_guest',
    defaultMessage: '{slots} guest ({amount} each)',
  },
  perSlot_player: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_player',
    defaultMessage: '{slots} players ({amount} each)',
  },
  perSlot_student: {
    id: 'feesBreakdown.shareAmountTitle.perSlot_student',
    defaultMessage: '{slots} students ({amount} each)',
  },

  claimedSlots: {
    id: 'feesBreakdown.shareAmountTitle.slots',
    defaultMessage: '{slots} {slotsName}',
  },
  claimedSlots_adult: {
    id: 'feesBreakdown.shareAmountTitle.slots_adult',
    defaultMessage: '{slots} adults',
  },
  claimedSlots_passenger: {
    id: 'feesBreakdown.shareAmountTitle.slots_passenger',
    defaultMessage: '{slots} passengers',
  },
  claimedSlots_ticket: {
    id: 'feesBreakdown.shareAmountTitle.slots_ticket',
    defaultMessage: '{slots} tickets',
  },
  claimedSlots_seat: {
    id: 'feesBreakdown.shareAmountTitle.slots_seat',
    defaultMessage: '{slots} seats',
  },
  claimedSlots_item: {
    id: 'feesBreakdown.shareAmountTitle.slots_item',
    defaultMessage: '{slots} items',
  },
  claimedSlots_shirt: {
    id: 'feesBreakdown.shareAmountTitle.slots_shirt',
    defaultMessage: '{slots} shirts',
  },
  claimedSlots_person: {
    id: 'feesBreakdown.shareAmountTitle.slots_person',
    defaultMessage: '{slots} people',
  },
  claimedSlots_guest: {
    id: 'feesBreakdown.shareAmountTitle.slots_guest',
    defaultMessage: '{slots} guests',
  },
  claimedSlots_player: {
    id: 'feesBreakdown.shareAmountTitle.slots_player',
    defaultMessage: '{slots} players',
  },
  claimedSlots_student: {
    id: 'feesBreakdown.shareAmountTitle.slots_student',
    defaultMessage: '{slots} students',
  },

  transactionFee: {
    id: 'feesBreakdown.transactionFee',
    defaultMessage: 'Transaction fee',
  },
  total: {
    id: 'feesBreakdown.total',
    defaultMessage: 'Total',
  },
  title: {
    id: 'feesBreakdown.title',
    defaultMessage: 'Fees breakdown',
  },
  headerDescription: {
    id: 'feesBreakdown.table.headers.description',
    defaultMessage: 'Description',
  },
  headerAmount: {
    id: 'feesBreakdown.table.headers.amount',
    defaultMessage: 'Amount',
  },
});

export class FeesBreakdown extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
  }
  get amount() { return money(this.props.amount); }

  get costPerSlot() { return money(this.props.costPerSlot); }

  get feesAmount() { return money(this.props.feesAmount); }

  get shareAmount() { return money(this.props.shareAmount); }

  get headers() {
    if (this.props.headers) return this.props.headers;
    return [
      this.formatMessage(i18n.headerDescription),
      this.formatMessage(i18n.headerAmount)
    ]
  }

  get title() {
    if (this.props.title) return this.props.title;
    return this.formatMessage(i18n.title);
  }

  shareAmountTitle() {
    const { claimedSlots } = this.props;

    if (this.costPerSlot) {
      return claimedSlots === 1 ?
        this.formatMessage(i18n.yourShare) :
        this.formatMessage(
          i18n.perSlot,
          {
            slots: claimedSlots,
            amount: format(this.costPerSlot)
          },
          this.props.slotName
        );
    }

    return claimedSlots === 1 ?
      this.formatMessage(i18n.yourShare) :
      this.formatMessage(i18n.claimedSlots, { slots: claimedSlots }, this.props.slotName);
  }

  buildConcepts() {
    const shareAmountTitle = this.shareAmountTitle();
    const concepts = [{ name: shareAmountTitle, amount: this.shareAmount }];

    if (!this.feesAmount.isZero()) {
      concepts.push({ name: this.formatMessage(i18n.transactionFee), amount: this.feesAmount });
    }

    return concepts;
  }

  render() {
    const concepts = this.buildConcepts();

    return (
      <div className="fees-breakdown">
        <Title text={this.title} divider />
        <table className="table">
          {renderHeaders(this.headers)}
          <tbody>
            {renderDetails(concepts)}
            <tr className="divider">
              <td className="text-right cool-grey">
                {this.formatMessage(i18n.total)}
              </td>
              <td className="text-right">
                {format(this.amount)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

const renderHeaders = headers => (
  <thead>
    <tr>
      {
        headers.map((title, index) => {
          const key = `title-${index}`;
          return <th className="small-print" key={key}>{title}</th>;
        })
      }
    </tr>
  </thead>
);

const renderDetails = concepts => {
  return concepts.map((concept, index) => {
    const key = `concept-${index}`;
    return (
      <tr key={key}>
        <td>{concept.name}</td>
        <td className="text-right">{format(concept.amount)}</td>
      </tr>
    );
  })

};

FeesBreakdown.defaultProps = {
  amount: null,
  shareAmount: null,
  costPerSlot: null,
  claimedSlots: 1,
  slotName: 'default',
};

export default injectIntl(FeesBreakdown);



// WEBPACK FOOTER //
// ./src/desktop/components/fees-breakdown.js